import { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

function Field({ count, color, size, radius, speed, opacity, tilt = 0.55 }) {
    const ref = useRef(null);
    const positions = useMemo(() => {
        const arr = new Float32Array(count * 3);
        for (let i = 0; i < count; i++) {
            const r = radius[0] + Math.random() * (radius[1] - radius[0]);
            const th = Math.random() * Math.PI * 2;
            const ph = Math.acos(2 * Math.random() - 1);
            arr[i * 3] = r * Math.sin(ph) * Math.cos(th);
            arr[i * 3 + 1] = r * Math.cos(ph) * tilt;
            arr[i * 3 + 2] = r * Math.sin(ph) * Math.sin(th);
        }
        return arr;
    }, [count, radius, tilt]);

    useFrame((_, d) => {
        if (ref.current) ref.current.rotation.y += d * speed;
    });

    return (
        <points ref={ref}>
            <bufferGeometry>
                <bufferAttribute attach="attributes-position" args={[positions, 3]} />
            </bufferGeometry>
            <pointsMaterial
                size={size}
                color={color}
                transparent
                opacity={opacity}
                blending={THREE.AdditiveBlending}
                depthWrite={false}
                sizeAttenuation
            />
        </points>
    );
}

function GlowRings() {
    const g = useRef(null);
    useFrame((state, d) => {
        if (!g.current) return;
        g.current.rotation.y += d * 0.05;
        const s = 1 + Math.sin(state.clock.elapsedTime * 0.7) * 0.02;
        g.current.scale.setScalar(s);
    });
    return (
        <group ref={g} position={[0, -0.1, -1.1]}>
            <mesh rotation={[1.45, 0, 0.2]}>
                <torusGeometry args={[2.05, 0.006, 8, 128]} />
                <meshBasicMaterial
                    color="#00F0FF"
                    transparent
                    opacity={0.32}
                    blending={THREE.AdditiveBlending}
                    depthWrite={false}
                    toneMapped={false}
                />
            </mesh>
            <mesh rotation={[1.2, 0.25, -0.3]}>
                <torusGeometry args={[2.65, 0.005, 8, 128]} />
                <meshBasicMaterial
                    color="#7000FF"
                    transparent
                    opacity={0.26}
                    blending={THREE.AdditiveBlending}
                    depthWrite={false}
                    toneMapped={false}
                />
            </mesh>
        </group>
    );
}

export { Field, GlowRings };
